class CustomPost {
  templateName = 'global__custom-post';

  constructor(app) {
    this.app = app;
    this.data = {};
    this.render();
  }

  static payload = {
    "id": 0,
    "image": "",
    "text": "",
    "twitter": "",
    "calendar": {"id": "", "name": ""},
    "name": "Post #0",
    "d": "",
    "plan": "free",
    "status": "Un Scheduled",
    "segments": "custom",
    "app_campaign_id": null
  }

  static saveCallback(response) {
    const app = PreBuilt;
    aimi_calendar.refresh(app.calendarId).then(function () {
      app.customPostContainer.modal('hide');
    });
  }

  static payloadProcessor(requestData) {
    requestData = {...this.payload, ...requestData};
    return requestData;
  }

  setImage($image, image) {
    $('[data-post-image]', this.container).empty().append($image)
    CustomPost.payload.image = image;
    $('input[name=image]', this.container).val(image);
  }

  render() {
    const self = this;
    CustomPost.payload.calendar = {id: this.app.calendarId, 'name': ''};
    const app = this.app;
    let options = {
      text: '',
      twitter: '',
      type: 'input',
      actionStatus : '',
      modalDialogClass: 'modal-lg modal-dialog-centered modal-dialog-scrollable modal-full-height modal-custom-post-editor',
      template: this.templateName,
      title: 'Custom Post Editor',
      saveButtonText: 'Add to Calendar',
      footerText: '',
      payloadProcessor: 'CustomPost.payloadProcessor',
      saveApi: 'calendar.addCustomPost',
      saveApiCallBack: 'CustomPost.saveCallback'
    }

    const page = _.template(this.app.templates['post_editor__partials-footer-text-versions']);
    options.placeholderPostEditorFooter = page(options);

    app.inputPrompt(options).then(function ($editor) {
      self.container = $editor;
      app.customPostContainer = self.container;

      const textAreas = $('textarea', $editor);
      const charCount = $('[data-character-count]', $editor)[0];

      textAreas.each(function (index, textarea) {
        textarea.addEventListener('input', () => app.updateCharCount(textarea, charCount));
      });

      $editor.off('click.tab').on('click.tab', `a[data-bs-toggle='tab']`, function () {
        let $this = $(this);
        const href = $this.attr('href');
        const tab = $(href);
        const textarea = tab.find('textarea')[0];
        if (href === '#tab_long_version') {
          app.updateCharCount(textarea, charCount);
        }
        if (href === '#tab_short_version') {
          app.updateCharCount(textarea, charCount);
        }
      })

      $('input[name="postTime"]', $editor).daterangepicker({
        singleDatePicker: true,
        autoUpdateInput: false,
        minDate: moment().startOf('hour'),
        timePicker: true,
        parentEl: $editor,
        showDropdowns: true,
        opens: 'left',
        locale: {
          format: 'MM/DD/YYYY hh:mm A'
        },
        "cancelClass": "btn-secondary",
        maxYear: parseInt(moment().format('YYYY'), 10) + 3
      }, function (start, end, label) {
        $('input[name="postTime"]', $editor).val(start.format('YYYY-MM-DD HH:mm'));
        const userTimeZone = app.apis['user'].get().timezone;
        CustomPost.payload.d = moment.tz(start.format('YYYY-MM-DD HH:mm'), userTimeZone).format();
      });

      $('[data-custom-post-action="add-image"]', $editor).off('click').on('click', function () {
        const $modal = app.infoModal('Image Library', '', {
          id: 'imageLibraryModal',
          dialogClass: 'modal-full modal-image-library '
        });

        const page = _.template(app.templates['image_library__modal']);
        const $imageModal = $(page());
        const $modalBody = $('.modal-body', $modal);
        $imageModal.appendTo($modalBody);

        const $tabContent = $imageModal.find('.tab-content');

        aimi_image_library.init($tabContent, '.modal-image-library', {
          images: {'addButton': true}
        });

        $modal.on('click', '.btn-add-to-post', function (e) {
          const $this = $(this);
          const $item = $this.closest('.infinite-item');
          let imageId = $item.data('id');
          const image = $item.data('org-src');

          const imageData = {};
          imageData.pathThumbnail = image;
          imageData.path = image;
          imageData.id = imageId;
          imageData.config = {images: {'addButton': false}};
          const $image = MyUploads.prepareRow(imageData, 'image_library__image-card');
          self.setImage($image, image);
          $modal.modal('hide');
        })

      })
    });
  }
}

// Creating a map of class references
window["CustomPost"] = CustomPost;